import React, { useState } from 'react'
import { CreateProduct } from '../ProductStore'
import { Modal, Button, Tooltip, Input } from 'antd-v4'
import { Icon } from 'antd'
import { GrRegex } from '../../../../../utilities/helpers'
import classNames from 'classnames'

interface ImportConfirmationModalProps {
  onClose: () => void
  product: CreateProduct
  onImport: () => void
}

export const SetProductNameModal = React.memo((props: ImportConfirmationModalProps) => {
  const { onImport, onClose, product } = props
  const inputValue = React.useRef(product.name)
  const [isInvalidProductName, setIsInvalidProductName] = useState(false)
  const [uniqueUnicodeArray, setUniqueUnicodeArray] = useState<string[] | null>(null)
  const onImportHandler = () => {
    props.product.setName(inputValue.current.trim())
    onImport()
  }

  const validateProductName = (name: string) => {
    const isValidName = name.match(GrRegex.unicodeRegex) === null
    setUniqueUnicodeArray(getUniqueUnicodeArray(name))
    setIsInvalidProductName(!isValidName)
  }

  const getUniqueUnicodeArray = (value: string): string[] | null => {
    const uniqueArray = value.toString().match(GrRegex.unicodeRegex)
    return uniqueArray === null ? null : [...new Set(uniqueArray)]
  }

  return (
    <Modal
      title='Confirm name'
      visible
      onCancel={onClose}
      footer={[
        <Button key='cancel' onClick={onClose}>
          Cancel
        </Button>,
        <Button
          disabled={isInvalidProductName}
          key='submit'
          type='primary'
          onClick={onImportHandler}
        >
          Import variants
        </Button>,
      ]}
    >
      <div className='mb-2'>What do you want the parent product to be named?</div>
      <div className='text-muted mb-2'>
        <small>
          For example, if you are importing Purple Kush 1g, Purple Kush 3.5g, and Purple Kush 7g,
          you may want to call the parent product "Purple Kush"
        </small>
      </div>
      <Input
        size='large'
        className='mb-3'
        defaultValue={product.name}
        onChange={(event) => {
          const { value: productName } = event.target
          validateProductName(productName)
          inputValue.current = productName
        }}
      />
      {uniqueUnicodeArray && (
        <small>
          <div className='text-danger'>
            Remove the following character(s): {uniqueUnicodeArray && uniqueUnicodeArray.join(', ')}
          </div>
        </small>
      )}
    </Modal>
  )
})
